import { ElementType } from 'react';
import { Fragment } from 'react';
import { FC } from 'react';
import { typograf } from '../utils/format';

interface Props {
    component?: ElementType;
}

export const Typograf: FC<Props> = ({
    component: Component = Fragment,
    children,
}) => {
    if (typeof children === 'string') {
        return <Component>{typograf.execute(children)}</Component>;
    }
    throw new Error('Компонент Typograf работает только со строками');
};
